import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {ChooseAddressComponent} from "./components/ChooseAddressComponent";
import {AddOrEditAddressComponent} from "./components/AddOrEditAddressComponent.jsx";

import {BasePanelPage} from "../../../PanelPage";
import {UserAddressStore} from "../../../../../client/state/UserAddressStore";
import {Messages} from "../../../../Messages";
import {wrapInSpinner} from "../../../../../core/ui/LoadingSpinner.jsx";
import {autoredraw} from "../../../../../stem-core/src/decorators/AutoRedraw.js";
import {FlowInputIntent} from "../../../flows/steps/BaseFlowStep.jsx";
import {Flow} from "../../../flows/Flow.js";
import {BlinkButton} from "../../../../../core/ui/Button.jsx";


@autoredraw(UserAddressStore)
export class AddressPanel extends BasePanelPage {
    getDefaultOptions(options) {
        return {
            ...super.getDefaultOptions(options),
            // TODO actually, should say something else
            title: () => Flow.address.inputIntent === FlowInputIntent.CHOOSE_VALUE ? Messages.chooseAddress : Messages.addNewAddress,
        };
    }

    getContinueButtonLabel() {
        return Flow.address.getContinueButtonLabel({
            [FlowInputIntent.EDIT_VALUE]: Messages.editAddress,
            [FlowInputIntent.ADD_VALUE]: Messages.addNewAddress,
        });
    }

    isContinueButtonDisabled() {
        return !(this.addressComponent?.isValid());
    }

    @wrapInSpinner
    async handleContinueButtonClick() {
        const userAddress = await this.addressComponent.getAddress();

        await Flow.address.selectValue(userAddress);
    }

    render() {
        const {styleSheet} = this;

        const AddressInputClass = Flow.address.getInputComponentClass({
            [FlowInputIntent.CHOOSE_VALUE]: ChooseAddressComponent,
            [FlowInputIntent.ADD_VALUE]: AddOrEditAddressComponent,
        });

        return [
            <AddressInputClass
                ref="addressComponent"
                onChange={() => this.redraw()}
            />,
            <BlinkButton
                ref="button"
                label={this.getContinueButtonLabel()}
                disabled={this.isContinueButtonDisabled()}
                onClick={() => this.handleContinueButtonClick()}
                className={styleSheet.actionButton}
            />,

            Flow.address.renderBackButton(),
        ]
    }

    onMount() {
        super.onMount();
        this.redraw(); // TODO @input needed for the button to not be disabled
    }
}
